import { GarageType } from "../types";

// A mock function to mimic making an async request for data
export function openCloseGates(garages: GarageType[], openAll: boolean) {
    return new Promise<{ data: GarageType[] }>((resolve) =>
        setTimeout(() => {
            resolve({

                data: garages.map(ele => {
                    return {
                        ...ele, isOpened: openAll
                    }
                })
            })
        }, 1500)
    );
}
export function openCloseGate(garages: GarageType[], gateId: number) {
    return new Promise<{ data: GarageType[] }>((resolve) =>
        setTimeout(() => {
            resolve({

                data: garages.map(ele => {
                    if (ele.id === gateId) {

                        return {
                            ...ele, isOpened: !ele.isOpened
                        }
                    } else {
                        return ele
                    }
                })
            })
        }, 1500)
    );
}
